import { inject, provide } from 'vue';
import { useGlobalId, useId } from '../hooks/index';
import { FORM_INJECTION_KEY } from '../types/constants';
import type { IFormProps } from '../types/Form';
import { Field } from './Field';

export class FormStore {
  name: string = `${useGlobalId()}`;
  fields: Map<number, Field> = new Map();
  #idController: ReturnType<typeof useId> = useId();

  disabled: boolean = false;
  // style controller
  colon: boolean = false;
  hideRequiredMark: boolean = false;
  labelAlign: 'left' | 'right' = 'left';
  layout: 'vertical' | 'horizontal' | 'inline' = 'vertical';
  constructor({ rules = {}, ...props }: IFormProps) {
    Object.assign(this, props);
  }
  destroy() {
    this.#idController.stop();
  }
  registerField() {
    const id = this.#idController.create();
    const field = new Field(id!);
    this.fields.set(id!, field);
    return field;
  }
}

export const registerFormStore = (props: IFormProps) => {
  const formStore = new FormStore(props);
  provide(FORM_INJECTION_KEY, formStore);
  return formStore;
};

export const useFormStore = () => {
  return inject(FORM_INJECTION_KEY);
};
